import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 1c.338 0 .671.017 1 .05V10h7V9a2 2 0 0 1 2-2h2v2h-2v2a9.973 9.973 0 0 1-3.23 7.36 3.506 3.506 0 0 0-1.68-1.187A7.988 7.988 0 0 0 18.937 12H3.062a7.995 7.995 0 0 0 3.211 5.455 3.516 3.516 0 0 0-1.392 1.455A9.983 9.983 0 0 1 1 11C1 5.477 5.477 1 11 1Zm-7.938 9h5.524L4.68 6.094A7.96 7.96 0 0 0 3.062 10Zm3.032-5.32L10 8.586V3.062A7.96 7.96 0 0 0 6.094 4.68Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.5 20.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM15 23a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconFinanceFamily24 = createIcon(IconComponent);